import React, { ReactNode } from 'react';
import reactStringReplace from 'react-string-replace';
import { warning } from '@ux/js';
export interface RenderCMSTextProps {
  values: Record<string, ReactNode>;
  text: string;
}

const RenderCMSText = (props: RenderCMSTextProps) => {
  const { values, text } = props;

  const renderedText = reactStringReplace(text, /{(?<value>[^{]*)}/g, (match, i) => {
    warning(values[match] != null, `no key passed in for ${match}`);
    return <React.Fragment key={i}>{values[match]}</React.Fragment>;
  });

  return <>{renderedText}</>;
};

RenderCMSText.displayName = 'RenderCMSText';

export default RenderCMSText;